namespace GeniuzPOS.Administration {
    export class UserColumns {
        static columnsKey = 'Administration.User';
    }
}
